import { useMemo } from 'react';

import {
  ACCESS_PASS_CONTRACT_ADDRESS,
  AUCTION_HOUSE_ADDRESS,
  ERC1155MINTABLE_ADDRESS,
  getCurrentChainType,
  MARKETPLACE_ADDRESS,
  MARKETPLACE_ADDRESS_ERC_721,
  MOVIE_CHEF_VOTING_ADDRESS,
  MOVIE_VOTING_ADDRESS,
  MOVIE_VOTING_NFT_ADDRESS,
  NFT_CONTRACT_ADDRESS,
  STARS_ADDRESS,
  STARS_ETH_CONTRACT_ADDRESS,
  STARS_MASTER_CHEF_ADDRESS,
  USDC_ADDRESS,
} from '../lib/smart-contract-utils';
import { useWeb3State } from './use-web3-state';

export const useContractAddress = () => {
  const { walletDetails } = useWeb3State();

  return useMemo(() => {
    const currentChainType = getCurrentChainType();

    return {
      STARS_ADDRESS: STARS_ADDRESS[currentChainType],
      STARS_ETH_CONTRACT_ADDRESS: STARS_ETH_CONTRACT_ADDRESS[currentChainType],
      STARS_MASTER_CHEF_ADDRESS: STARS_MASTER_CHEF_ADDRESS[currentChainType],
      ACCESS_PASS_CONTRACT_ADDRESS:
        ACCESS_PASS_CONTRACT_ADDRESS[currentChainType],
      USDC_ADDRESS: USDC_ADDRESS[currentChainType],
      AUCTION_HOUSE_ADDRESS: AUCTION_HOUSE_ADDRESS[currentChainType],
      MARKETPLACE_ADDRESS: MARKETPLACE_ADDRESS[currentChainType],
      MARKETPLACE_ADDRESS_ERC_721:
        MARKETPLACE_ADDRESS_ERC_721[currentChainType],
      NFT_CONTRACT_ADDRESS: NFT_CONTRACT_ADDRESS[currentChainType],
      ERC1155MINTABLE_ADDRESS: ERC1155MINTABLE_ADDRESS[currentChainType],
      MOVIE_VOTING_ADDRESS: MOVIE_VOTING_ADDRESS[currentChainType],
      MOVIE_CHEF_VOTING_ADDRESS: MOVIE_CHEF_VOTING_ADDRESS[currentChainType],
      MOVIE_VOTING_NFT_ADDRESS: MOVIE_VOTING_NFT_ADDRESS[currentChainType],
    };
  }, [walletDetails.chain.id]);
};
